import { styled } from '../../Utilities';
import { KeytipContentBase } from './KeytipContent.base';
import { getStyles } from './Keytip.styles';
export var KeytipContent = styled(KeytipContentBase, getStyles, undefined, {
    scope: 'KeytipContent'
});
//# sourceMappingURL=KeytipContent.js.map